import { Component } from '@angular/core';

@Component({
  selector: 'app-action-buttons-skeleton',
  standalone: true,
  templateUrl: './action-buttons-skeleton.component.html',
  styleUrl: './action-buttons-skeleton.component.scss'
})
export class ActionButtonsSkeletonComponent {
  numberOfButtons = new Array(2);
}
